import * as React from 'react';
import { Icon } from './Icon';
import { Link } from 'react-router-dom';

export interface StepsWrapperProps {
    children: any;
}

export function StepsWrapper(props: StepsWrapperProps) {
    return (
        <ul className='steps steps--justified'>
            {props.children}
        </ul>
    );
}

export interface StepProps {
    href: string;
    children: any;
    label: string;
    state: 'done' | 'active' | 'ahead';
}

export function Step(props: StepProps) {
    let label: any = props.label;
    if (props.state === 'done') {
        label = <Icon name='success'/>;
    }
    
    return (
        <li className='steps__item'>
            <Link to={props.href} className={'steps__item__link' + (props.state === 'ahead' ? ' step-ahead' : '')}>{label}</Link>
            <div className='steps__item__content'>{props.children}</div>
        </li>
    );
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/Steps.tsx